import BN from 'bignumber.js';

export const calculateStakeBalance = (balance, price) => {
  const priceIsNaN = new BN(price).isNaN();

  return priceIsNaN ? '0' : new BN(price).times(balance).toFixed(0, BN.ROUND_DOWN);
};

export const getPrice = async (stakeTokenContractService) => {
  if (!stakeTokenContractService) {
    throw new Error("contract service wasn't provided");
  }

  const [totalSupply, totalStaked, lockedRewards, unlockedRewards] = await Promise.all([
    stakeTokenContractService.totalSupply(),
    stakeTokenContractService.totalStaked(),
    stakeTokenContractService.lockedRewards(),
    stakeTokenContractService.getUnlockedRewards(),
  ]);
  return new BN(totalStaked).plus(BN.min(unlockedRewards.unlocked, lockedRewards)).div(totalSupply);
};
